/* eslint-disable react/no-array-index-key, react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';

import { useResizeObserver } from '../../hooks/useObserver';
import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import { useFloatingVideo } from '../../contexts/VideoContext';
import Blocks from '../blocks/Blocks';
import ProjectHeader from '../headers/ProjectHeader';
import RelatedFooter from '../partials/RelatedFooter';

import styles from '../../../styles/pages/project.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ProjectPage = ({ page, className }) => {
    const { title = null, blocks = null, related = [] } = page || {};
    const { setFloatingVideo } = useFloatingVideo();

    const {
        ref,
        entry: { contentRect = null },
    } = useResizeObserver();

    const { video = null, blocksWithVideo = [] } = useMemo(() => {
        let currentVideo = null;
        // This should be a reduce..?
        const blocksMap = (blocks || []).map((block) => {
            const { type = null, video: blockVideo = null, embed: blockEmbed = null } = block || {};
            // Only one per page, first block
            if (currentVideo !== null) {
                return block;
            }

            if (type === 'video' && blockVideo !== null) {
                currentVideo = blockVideo;
                return { ...block, isVideoSlot: true };
            }
            if (type === 'embed' && blockEmbed !== null) {
                const { type: embedType = null } = blockEmbed || {};
                if (embedType === 'video' && blockEmbed !== null) {
                    currentVideo = blockEmbed;
                    return { ...block, isVideoSlot: true };
                }
            }
            return block;
        }, []);

        return {
            video: currentVideo,
            blocksWithVideo: blocksMap,
        };
    }, [page, contentRect]);

    useScrollToTop(page);

    useEffect(() => {
        setFloatingVideo(video, { title });
    }, [title, video, blocksWithVideo, setFloatingVideo]);

    return (
        <>
            <article
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
                ref={ref}
            >
                <ProjectHeader className={styles.header} project={page} />
                <div className={styles.content}>
                    {blocksWithVideo !== null ? (
                        <Blocks
                            className={styles.blocks}
                            blocks={blocksWithVideo}
                            isContainer
                            typeClassName={{
                                video: styles.videoBlock,
                                embed: styles.videoBlock,
                            }}
                        />
                    ) : null}
                </div>
            </article>
            <RelatedFooter items={related} />
        </>
    );
};

ProjectPage.propTypes = propTypes;
ProjectPage.defaultProps = defaultProps;

export default ProjectPage;
